<ion-header class="ion-no-border">
  
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md"></ion-back-button>
    </ion-buttons>
    <ion-title>
      {{ (booking.getId() == undefined) ? 'New' : '' }} Blocked Time Off
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
<ng-container>
    <form [formGroup]='timeOffForm'>
    <ion-row>
      <ion-col class="hidden-sm-down"></ion-col>
      <ion-col size="12" size-sm="12" size-md="8" size-lg="8" size-xl="8">
        <ion-button expand="block" fill="clear" (click)="onBookingStartDateTimeTap()">
          <div class="button-text">
            {{ booking.getStartDateTime() | salonMonsterDate: 'ddd, MMM D Y h:mm a'}}
          </div>
          <ion-icon name="create" class="edit-icon"></ion-icon>
        </ion-button>
      
      
        <ion-item lines="none">
          <ion-label position="stacked">Duration</ion-label>
          <ion-select formControlName="durations">
            <ion-select-option *ngFor="let timeslot of timeSlots" [value]="timeslot.value">
              {{timeslot.label}}
            </ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item [hidden]="durations.valid || (durations.pristine && !submitted)">
          <p *ngIf="durations.hasError('required')">
            Duration is required
          </p>
        </ion-item>

        <ion-item lines="none">
          <ion-label class="smr-recurring-label">Recurring</ion-label>
          <ion-toggle [checked]="booking.isRecurring()" (ionChange)="onRecurringToggleChange($event)"></ion-toggle>  
        </ion-item>

        <ion-row *ngIf="booking.isRecurring()">
        <ion-col width-25>
          <ion-item lines="none">
            <ion-select formControlName="frequencyCount" (ionChange)="onRecurringFrequencyCountChange()">
              <ion-select-option *ngFor="let type of frequencyCountOptions" [value]="type.value">
                {{type.name}}
              </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
        <ion-col>
          <ion-item lines="none">
            <ion-select formControlName="frequencyType" (ionChange)="onRecurringFrequencyTypeChange()">
              <ion-select-option *ngFor="let type of frequencyTypes" [value]="type.value">
                {{type.name}}
              </ion-select-option>
            </ion-select>
          </ion-item>
      </ion-col>
      </ion-row>

        <ion-item lines="none">
          <ion-label position="stacked">Description(optional)</ion-label>
          <ion-textarea formControlName="notes"></ion-textarea>
        </ion-item>

        <!--ion-item [hidden]="notes.valid || (notes.pristine && !submitted)">
          <p *ngIf="notes.hasError('required')">
            Description is required
          </p>
        </!--ion-item-->

          <ion-button expand="block"  fill="clear" color="danger" *ngIf="booking.getId() != undefined" (click)="onTimeOffDelete()"> 
            <span *ngIf="!deletionInProgress">Delete Time off</span>
            <ion-spinner name="crescent" *ngIf="deletionInProgress"></ion-spinner>
          </ion-button>

    <!--ion-grid>
      <ion-row>
        <ion-col class="ion-text-center">
          <ion-button expand="block" fill="clear" (click)="onBookingStartDateTimeTap()">
            {{ booking.getStartDateTime() | salonMonsterDate: 'ddd, MMM D Y h:mm a'}}
        </ion-button>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <ion-item lines="none">
            <ion-label position="stacked">Duration</ion-label>
            <ion-select formControlName="durations">
              <ion-select-option *ngFor="let timeslot of timeSlots" [value]="timeslot.value">
                {{timeslot.label}}
              </ion-select-option>
            </ion-select>
          </ion-item>

          <ion-item [hidden]="durations.valid || (durations.pristine && !submitted)">
            <p *ngIf="durations.hasError('required')">
              Duration is required
            </p>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <ion-item>
            <ion-label>Recurring</ion-label>
            <ion-toggle [checked]="booking.isRecurring()" (ionChange)="onRecurringToggleChange($event)"></ion-toggle>  
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="booking.isRecurring()">
        <ion-col size="25">
          <ion-item>
            <ion-select formControlName="frequencyCount" (ionChange)="onRecurringFrequencyCountChange($event)">
              <ion-select-option *ngFor="let type of frequencyCountOptions" [value]="type.value">
                {{type.name}}
              </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>

        <ion-col>
          <ion-item>
            <ion-select formControlName="frequencyType" (ionChange)="onRecurringFrequencyTypeChange($event)">
              <ion-select-option *ngFor="let type of frequencyTypes" [value]="type.value">
                {{type.name}}
              </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <ion-item>
            <ion-label position="stacked">Notes</ion-label>
            <ion-textarea formControlName="notes"></ion-textarea>
          </ion-item>

          <ion-item [hidden]="notes.valid || (notes.pristine && !submitted)">
            <p *ngIf="notes.hasError('required')">
              Description is required
            </p>
          </ion-item>
        </ion-col>
      </ion-row>
      <br/>
      <ion-row>
        <ion-col>
          <ion-button expand="block"  fill="clear" color="danger" *ngIf="booking.getId() != undefined" (click)="onTimeOffDelete()"> 
            <span *ngIf="!deletionInProgress">Delete blocked time</span>
            <ion-spinner name="crescent" *ngIf="deletionInProgress"></ion-spinner>
          </ion-button>
        </ion-col>
      </ion-row>
    </!--ion-grid-->
  
</ion-col>
<ion-col class="hidden-sm-down"></ion-col>
</ion-row>
</form>
</ng-container>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-button 
    expand="block" 
    
    class="ion-no-margin"
    color="primary" 
    (click)="onTimeOffSave()" 
    [disabled]="!timeOffForm.valid"
  > 
    <span *ngIf="!savingInProgress">{{ (booking.getId() == undefined) ? 'Book' : 'Update' }}</span>
    <ion-spinner name="crescent" *ngIf="savingInProgress"></ion-spinner>
  </ion-button>
</ion-footer>